export const OrderSubscriptionSummaryFragment = /* GraphQL */ `
	fragment OrderSubscriptionSummary on Order {
		_id
		device
		location
		updated_at
		index
		status
		prep_time
		is_paid
		is_cancelled
		is_needing_payment_confirmation
		is_request_payment_confirmation
		is_needing_prep_time_confirmation
		is_needing_prep_time_acknowledgement
	}
`;
